import { CallAgent, RetellVoice, RetellWebCallAccessToken } from '../models';
import { ModelResource } from './resource';

export class CallAgents extends ModelResource<CallAgent> {
  model = CallAgent;

  resourcePath = 'v1/call-agent';

  async getWebCallAccessToken(): Promise<RetellWebCallAccessToken> {
    return this.api
      .post(this.path('web-call-token'))
      .then((response) => RetellWebCallAccessToken.fromJson(response.data));
  }

  async listLanguages(): Promise<string[]> {
    const response = await this.api.get(this.path('languages'));
    return response.data.languages;
  }

  async listVoices(): Promise<RetellVoice[]> {
    return this.api.get(this.path('voices')).then((response) => {
      return response.data.data.map((e) => RetellVoice.fromJson(e));
    });
  }

  async provisionPhoneNumber(data: { phone_number: string }): Promise<string> {
    const response = await this.api.post(this.path('phone-number'), { data });

    return response.data.phone_number as string;
  }
}
